import silent from "./res/silent.mp3";
import scanner_beep from "./res/scanner_beep.ogg";
import beep from "./res/beep.ogg";

const VIBRATION_DURATION_IN_MS = 500;

function initializeSoundObject(resource) {
  let audio = new Audio(resource);
  audio.preload = "auto";
  return audio;
}

let silent_sound = initializeSoundObject(silent);
let scanner_beep_sound = initializeSoundObject(scanner_beep);
let beep_sound = initializeSoundObject(beep);

export const SoundType = {
  SILENT: silent_sound,
  SCANNER_BEEP: scanner_beep_sound,
  BEEP: beep_sound,
};

export const SoundManager = {
  playSilentSound: () => {
    SoundType.SILENT.play().catch((error) => {
      console.log("Unable to play silent sound" + error);
      //TODO: Logger
    });
    if (window.navigator.vibrate) {
      window.navigator.vibrate(VIBRATION_DURATION_IN_MS);
    }
  },
  playErrorSound: () => {
    SoundType.SCANNER_BEEP.play().catch((error) => {
      console.log("Unable to play scanner beep sound" + error);
      //TODO: Logger
    });
    if (window.navigator.vibrate) {
      window.navigator.vibrate(VIBRATION_DURATION_IN_MS);
    }
  },
  playSuccessSound: () => {
    SoundType.BEEP.play().catch((error) => {
      console.log("Unable to play beep sound" + error);
      //TODO: Logger
    });
    if (window.navigator.vibrate) {
      window.navigator.vibrate(VIBRATION_DURATION_IN_MS);
    }
  },
};
